import { render, staticRenderFns } from "./responsiblePersonsMain.vue?vue&type=template&id=c3f67d0a&scoped=true&"
import script from "./responsiblePersonsMain.vue?vue&type=script&lang=js&"
export * from "./responsiblePersonsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f67d0a",
  null
  
)

export default component.exports